import {BudgetType, PeriodBudgetType} from '../../../../../../constants';

export enum TileVariant {
	DatesAndRevenue,
	EstimateAndTime,
	RemainingAndBaseline,
	Availability,
}

// INTERMEDIATE SHARED TYPES. The following types should eventually become obsolete as the surrounding input is refactored to TS, and the types should be pulled from there instead
// Since input is not typesafe, all input is considered partial.
type TotalsData = {
	startDateString: string;
	endDateString: string;
	progress: number;
	plannedRevenue: number;
	actualRevenue: number;
	actualRevenueForProject: number;
	totalPriceAtCompletion: number;
	totalPriceAtCompletionForTasks: number;
	totalPriceAtCompletionForProject: number;
	estimate: number;
	estimateOnTasks: number;
	timeEntries: number;
	billableTimeEntries: number;
	timeEntriesOnTasks: number;
	timeEntriesOnProject: number;
	remaining: number;
	remainingOnTasks: number;
	difference: number;
	varianceOnTasks: number;
	totalAvailability: number;
	remainingAvailability: number;
	baselineTargetHours: number;
	baselineTargetPrice: number;
	allTotalTimeAndExpensesAtCompletion: number;
	projectedTotalCost: number;
	projectedTotalRevenue: number;
	projectedTotalProfit: number;
	projectedTotalMargin: number;
	projectedTotalHours: number;
	actualHours: number;
	actualBillableHours: number;
	actualNonBillableHours: number;
	projectedBillableValueOfService: number;
	baselineHours: number;
	isEstimatedInHours;
	allocatedHours: number;
	estimatedHours: number;
	remainingHours: number;
	baselineRevenue: number;
	plannedCost: number;
	baselineCost: number;
	actualCost: number;
	projectedBillableHours: number;
	projectedNonBillableHours: number;
	plannedProfit: number;
	baselineProfit: number;
	plannedMargin: number;
	estimatedPoints: number;
	completedPoints: number;
	remainingPoints: number;
	remainingCost: number;
	baselineMargin: number;
	billableActualValueOfService: number;
	actualValueOfService: number;
	baselineValueOfService: number;
	projectedTotalValueOfService: number;
	remainingBudget: number;
	overUnderServicing: number;
	percentageActualBillableHours: number;
	percentageProjectedTotalBillableHours: number;
};

type ProjectData = {
	manualProgressOnProjectEnabled?: boolean;
	budget?: number;
	budgetType?: BudgetType;
	defaultPeriodBudgetType?: PeriodBudgetType;
	useAllocationsForPlannedValues?: boolean;
	hasAllocations?: boolean;
	useBaseline?: boolean;
};

type FinancialSourceSettings = {
	plannedRevenue: string;
	actualRevenue: string;
	forecastRevenue: string;
};
type Settings = {
	currencySymbol?: string;
	isPointsProject?: boolean;
	isBaselineProject?: boolean;
	financialSourceSettings?: FinancialSourceSettings;
	isUsingProjectAllocation?: boolean;
};

export type TotalsContextData = {
	totalsExpanded: boolean;
	toggleTotalsExpanded: () => void;
	projectData: ProjectData;
	settings: Settings;
	totalsData: TotalsData;
};
